var styles = {
  "card": "_card_8eiijj_6",
  "themeLight": "_themeLight_8eiijj_40",
  "withStaticBorder": "_withStaticBorder_8eiijj_43",
  "themeDark": "_themeDark_8eiijj_49",
  "cardPlain": "_cardPlain_8eiijj_59",
  "modeClassic": "_modeClassic_8eiijj_59",
  "modeRock": "_modeRock_8eiijj_60",
  "paddings16": "_paddings16_8eiijj_197",
  "paddings24": "_paddings24_8eiijj_201",
  "paddings32": "_paddings32_8eiijj_205",
  "withStatesBorder": "_withStatesBorder_8eiijj_81",
  "glowHover": "_glowHover_8eiijj_120",
  "bordersRadius0": "_bordersRadius0_8eiijj_209",
  "bordersRadius8": "_bordersRadius8_8eiijj_213",
  "bordersRadius16": "_bordersRadius16_8eiijj_217",
  "bordersRadius24": "_bordersRadius24_8eiijj_221",
  "cardImage": "_cardImage_8eiijj_225",
  "cardImageImg": "_cardImageImg_8eiijj_233",
  "cardImageDiv": "_cardImageDiv_8eiijj_266",
  "fixedImageHeight": "_fixedImageHeight_8eiijj_301",
  "fullImageWidth": "_fullImageWidth_8eiijj_318"
};
export { styles as default };
